import React from 'react';
export function LocationsHero() {
  return <section className="bg-slate-50 py-16 md:py-24 border-b border-slate-200" data-id="element-546">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-547">
        <h1 className="text-4xl md:text-5xl font-bold text-[#1a2332] mb-6" data-id="element-548">
          Our Locations
        </h1>
        <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-549">
          Proudly serving families across Michigan with professional martial
          arts training in multiple convenient locations.
        </p>
      </div>
    </section>;
}